import { resolveCountry, LOCALE_BY_COUNTRY } from "./FormatByCountry";

const formatInputMoney = (num: any) => {
  const locale = LOCALE_BY_COUNTRY[resolveCountry()];
  if (num) {
    return Math.abs(Number(num)).toLocaleString(locale);
  }
  return num.toString();
};
export default formatInputMoney;
